import { render, staticRenderFns } from "./AssignedTo.vue?vue&type=template&id=4282458e&scoped=true&"
import script from "./AssignedTo.vue?vue&type=script&lang=js&"
export * from "./AssignedTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4282458e",
  null
  
)

/* custom blocks */
import block0 from "./AssignedTo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports